import EVENTS from "../constants/events";
import {createBrowserHistory, History} from 'history';
import {Service} from "../interface/service";
import EventsHandler from "./events";

const queryString = require('query-string');

export class HistoryService implements Service {

    protected history: History<any>;
    protected unlisten: any;
    protected started: boolean = false;
    protected hiddenState: any = {};
    public events: EventsHandler;

    constructor(eventEmitter: EventsHandler) {
        this.events = eventEmitter;
    }

    start = () => {
        this.history = createBrowserHistory();
        this.bindUI();
    }

    public getLocation = () => this.history.location;
    public setHiddenState = (key: string, hidden: any) => this.hiddenState[key] = hidden;

    public getState = (state ?: string, includeHidden: boolean = true) => {
        let newState = queryString.parse(state ? state : this.getLocation().search, {arrayFormat: 'bracket'});
        if (includeHidden) {
            newState = {...this.hiddenState, ...newState};
        }
        return newState;
    }

    private bindUI = () => {
        if (!this.started) {
            this.events.addListener(EVENTS.HISTORY_PUSH, this.handlePush);
            this.events.addListener(EVENTS.HISTORY_POP_AND_PUSH, this.handlePopAndPush);
            this.started = true;
        }
        this.unlisten = this.history.listen(<any>this.handleHistoryUpdate);
        this.handleHistoryInitialise();
    };

    /**
     * When the application is loaded we need to initialise the history
     */
    private handleHistoryInitialise = () => {
        this.events.emit(EVENTS.STATE_CHANGE, location, this.getState());
    }

    /**
     * Triggered whenever the state of the history changes
     * @param state
     */
    private handleHistoryUpdate = (state: any) => {
        this.events.emit(EVENTS.STATE_CHANGE, state.location, this.getState(state.location.search));
    }
    
    private handlePopAndPush = (path: string, state: any) => {
        let params = this.getParamsFromState(state);
        this.history.replace(
            location.pathname + '?' + queryString.stringify(params, {arrayFormat: 'bracket'}),
            params
        );
    }

    /**
     * Handle the push of a new state to the history
     * @param path
     * @param state
     */
    private handlePush = (path: string, state: any) => {
        let params = this.getParamsFromState(state);
        this.history.push(
            location.pathname + '?' + queryString.stringify(params, {arrayFormat: 'bracket'}),
            params
        );
    }

    private getParamsFromState = (state: any) => {
        let params = this.getState();
        if (undefined !== state) {
            let keys = Object.keys(state).concat(Object.keys(params));
            keys.forEach((key: any) => {
                if (null === state[key] || '' === state[key]) {
                    delete state[key];
                    delete params[key];
                } else {
                    params[key] = state[key];
                }
            });
        }
        return params;
    }
}